export const SET_IS_MOBILE_MENU_OPEN = 'SET_IS_MOBILE_MENU_OPEN';
export const SET_IS_MOBILE_SITE = 'SET_IS_MOBILE_SITE';
export const SET_JOIN_BUTTON = 'SET_JOIN_BUTTON';
export const CREATE_CONTACT = 'CREATE_CONTACT';

// Contacts
export const CONTACT_SUBMIT = 'CONTACT_SUBMIT';
export const GET_CONTACTS = 'GET_CONTACTS';
